import { UIStoreGiftOverlayController } from '../../../../../shared/scripts/store/gift/UIStoreGiftOverlayController.ts';
import { UIMMobileWebviewCommunication } from '../../../ui_mobile_communication/UIMMobileWebviewCommunication.ts';
import { MobileWebviewCommunicationActions } from '@colonist/mobile';
import { UIMDeviceHandler } from '../../UIMDeviceHandler.ts';
import { ClientUserState } from '../../../../../shared/scripts/ClientUserState.ts';
import { ColonistGiftMembershipProduct } from '../../../../../../shared/store/ColonistGiftMembershipProduct.ts';
import { UIAPIEndpoints } from '../../../../../shared/scripts/network/UIAPIEndpoints.ts';
import { UIAjaxWrapper } from '../../../../../shared/scripts/network/UIAjaxWrapper.ts';
import { UIMDoubleTapPurchaseController } from '../UIMDoubleTapPurchaseController.ts';
import { StoreProductType } from '../../../../../../shared/store/BaseColonistStoreProduct.ts';
import { sendDoubleTapPaymentAbandonedAnalytic, sendPurchaseSessionStartedAnalytic } from '../../../../../shared/scripts/analytics/sendPurchaseFunnelAnalytic.ts';
export class UIMStoreGiftOverlayController extends UIStoreGiftOverlayController {
    async executeCheckout(giftTier, giftPurchaseData) {
        const doubleTapPurchaseController = UIMDoubleTapPurchaseController.getInstance();
        const selectedProduct = UIMStoreGiftOverlayController.findGiftProduct(giftTier);
        const isDoubleTapPurchaseInitialized = doubleTapPurchaseController != undefined && selectedProduct != undefined;
        if (!isDoubleTapPurchaseInitialized) {
            await this.executeNonDoubleTabCheckout(giftTier, giftPurchaseData);
            return;
        }
        doubleTapPurchaseController.startPurchase({
            productName: selectedProduct.getProductName(),
            usdCentsAmount: selectedProduct.price,
            storeProductType: StoreProductType.OneTimePurchase,
            productType: giftTier,
            itemQuantity: giftPurchaseData.duration,
            giftPurchaseData: giftPurchaseData,
            onPaymentSheetShown: ()=>sendPurchaseSessionStartedAnalytic({
                    storeProductType: StoreProductType.OneTimePurchase,
                    productType: giftTier,
                    method: 'doubleTap'
                }),
            onPurchaseCancel: ()=>sendDoubleTapPaymentAbandonedAnalytic({
                    storeProductType: StoreProductType.OneTimePurchase,
                    productType: giftTier
                }),
            onPurchaseFinished: ({ shouldExecuteFallbackPurchase, isSuccessfulPurchase })=>{
                if (isSuccessfulPurchase) this.hide();
                if (shouldExecuteFallbackPurchase) void this.executeNonDoubleTabCheckout(giftTier, giftPurchaseData);
            }
        });
    }
    async executeNonDoubleTabCheckout(giftTier, giftPurchaseData) {
        const selectedProduct = UIMStoreGiftOverlayController.findGiftProduct(giftTier);
        if (UIMDeviceHandler.shouldEnableNativePaymentsOnMobile() && ClientUserState.userState && selectedProduct) {
            const result = await UIAjaxWrapper.postRequestHandler(UIAPIEndpoints.apiSaveGiftMetadata(), undefined, giftPurchaseData);
            if (result == undefined) return;
            const giftMetadataId = result.json;
            sendPurchaseSessionStartedAnalytic({
                storeProductType: StoreProductType.OneTimePurchase,
                productType: giftTier,
                method: 'nativeIap'
            });
            UIMMobileWebviewCommunication.sendPayloadToMobile(MobileWebviewCommunicationActions.GiftMembership, {
                productId: selectedProduct.mobileIAPSKUId,
                metadataId: `${giftMetadataId}`
            });
            return;
        }
        void super.executeCheckout(giftTier, giftPurchaseData);
    }
    static findGiftProduct(giftTier) {
        const allProducts = ColonistGiftMembershipProduct.getAllMembershipProducts();
        return allProducts.find((product)=>product.oneTimePurchaseType == giftTier);
    }
}
